// 各市州征订覆盖率模块
const state = {
  list: []
}

const mutations = {
  SET_DATA(state, data) {
    if (data && Array.isArray(data)) {
      state.list = data.map(item => ({
        cityId: item.cityId,
        cityName: item.cityName,
        sjzd: item.sjzd || 0,      // 实际征订人数
        yzd: item.yzd || 0,         // 应征订人数
        zb: item.zb || '0%',        // 覆盖率
        amount: item.amount || 0    // 码洋
      }))
    } else {
      state.list = []
    }
  },
  RESET_DATA(state) {
    state.list = []
  }
}

const getters = {
  list: state => state.list,
  // 按覆盖率排序
  sortedByRate: state => {
    return [...state.list].sort((a, b) => parseFloat(b.zb) - parseFloat(a.zb))
  },
  // 按码洋排序
  sortedByAmount: state => {
    return [...state.list].sort((a, b) => b.amount - a.amount)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
